import request from "@/utils/request";

export function getDetail(data) {
  return request({
    url: "/v31",
    method: "post",
    data,
  });
}
